import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, ViewChild, AfterViewInit, AfterViewChecked } from '@angular/core';
import { UtilService, NotificationService, DialogService } from '../../shared/index';
import { DatagridService } from '../../shared/widgets/datagrid/datagrid.service';
import { StringValueAccessor, CreateStringValueAccessorProvider } from '../../shared/widgets/value-accessors/string-value-accessor';
import { ImageService } from '../shared/image/image.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '../shared/config.service';
import { AppContext } from '../shared/app-context.model';

import { Image } from '../shared/image/image.model';
import { ImageSearchParams } from '../shared/image/image-search-params.model';
import { ImageSearchResult } from '../shared/image/image-search-result.model';
import { NameValue } from '../../shared/model/name-value.model';
import { WebContentServiceService } from 'src/app/web-content/shared/web-content-service.service';

@Component({
  selector: 'wl-image-lookup',
  templateUrl: 'image-lookup.component.html',
  styleUrls: ['image-lookup.component.css'],
  providers: [ImageService, CreateStringValueAccessorProvider(ImageLookupComponent)],
  standalone: false,
})
export class ImageLookupComponent extends StringValueAccessor {
  //for validation to know if "" or null can be allowed
  @Input() required: any;
  @Input() profileId: number;
  @Input() helpIconTitle: string;
  @Input() autoSelectOnImageUpload: boolean = false;
  @Output() onImageChanged = new EventEmitter<Image>();
  @Output() onImageSelected = new EventEmitter<Image>();

  public _utilService: UtilService;
  public _imageService: ImageService;
  public _dataGridService: DatagridService;
  public _dialogService: DialogService;
  public _translateService: TranslateService;
  public _configService: ConfigService;

  public _lastValue: string;

  public imageSearchResult: ImageSearchResult;
  public selectedImage: Image;
  public searchParams: ImageSearchParams;
  public showSearch: boolean;
  public imageTypes: Array<NameValue>;
  public selectedImageTypeId: number;
  public searchHasResults: boolean;
  public searchPerformed: boolean;
  public uploadImageUrl: string;
  public isSearching: boolean;
  public showHelpIcon: boolean;

  public webServerBaseImageSourceUrl: string;
  public appContext: AppContext;

  public imageSelectedSource: string;

  public constructor(
    imageService: ImageService,
    translateService: TranslateService,
    utilService: UtilService,
    dataGridService: DatagridService,
    configService: ConfigService,
    private _webContentService: WebContentServiceService
  ) {
    super();
    this._imageService = imageService;
    this._translateService = translateService;
    this._utilService = utilService;
    this._dataGridService = dataGridService;
    this._configService = configService;

    this.imageSearchResult = new ImageSearchResult();

    this.selectedImage = new Image();

    this._lastValue = 'abcxyz123';
    this.searchParams = new ImageSearchParams();
    this.showSearch = false;
    this.imageTypes = new Array<NameValue>();
    this.selectedImageTypeId = 0;
    this.searchHasResults = false;
    this.searchPerformed = false;

    this.uploadImageUrl = this._webContentService.getWebContentImageUrl();
    this.isSearching = false;
    this.appContext = new AppContext();

    this.imageSelectedSource = '';
    this.profileId = 0;
  }

  //this overrides the base class function to set
  //what it means for this this control to be valid
  public isValid = (): boolean => {
    if (this._utilService.isNotNullOrUndefined(this.required)) {
      if (this._utilService.isNotNullEmptyOrWhitespace(this.value)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  ngOnInit() {
    this._configService.getAppContext().then((data: AppContext) => {
      this.appContext = data;
      this.webServerBaseImageSourceUrl = this.appContext.FullSecureURL_ImagesFolder;
      this.updateSelectedImageSource();
    });
    this._translateService
      .get([
        'config.image-lookup.component.image-types.all',
        'config.image-lookup.component.image-types.web-content',
        'config.image-lookup.component.image-types.file-based',
        'config.image-lookup.component.image-types.upload-file',
      ])
      .subscribe((result: any) => {
        this.imageTypes = new Array<NameValue>();
        let imageType1 = new NameValue();
        let imageType2 = new NameValue();
        let imageType3 = new NameValue();
        let imageType4 = new NameValue();
        imageType1.name = this._utilService.toTitleCase(result['config.image-lookup.component.image-types.all'].toString());
        imageType1.value = 0;
        imageType2.name = this._utilService.toTitleCase(result['config.image-lookup.component.image-types.web-content'].toString());
        imageType2.value = 1;
        imageType3.name = this._utilService.toTitleCase(result['config.image-lookup.component.image-types.file-based'].toString());
        imageType3.value = 2;
        imageType4.name = this._utilService.toTitleCase(result['config.image-lookup.component.image-types.upload-file'].toString());
        imageType4.value = 3;

        this.imageTypes.push(imageType1);
        this.imageTypes.push(imageType2);
        this.imageTypes.push(imageType3);
        this.imageTypes.push(imageType4);

        this.updateSelectedImageSource();
      });

    this.searchImages(null);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.emitOutputObject();
  }

  public modelChange() {
    this.emitOutputObject();
  }

  public emitOutputObject = (): void => {
    //if (this._utilService.isNotNullEmptyOrWhitespace(this.value)) {
    if (this) {
      this.onImageChanged.emit(this.selectedImage);
      this.updateSelectedImageSource();
    }

    //} else {
    //    this.updateSelectedImageSource();
    //}
  };

  public updateSelectedImageSource = (): void => {
    if (this._utilService.isNotNullEmptyOrWhitespace(this.value)) {
      if (this.value.search && this.value.search(/^https?:\/\//i) < 0) {
        this.imageSelectedSource = this.appContext.WebRootSecure + '/' + this.value;
      } else {
        this.imageSelectedSource = this.value;
      }
    } else {
      this.imageSelectedSource = '';
    }
  };
  public displaySearch = (): void => {
    this.showSearch = true;
  };
  public hideSearch = (): void => {
    this.showSearch = false;
  };
  public searchImages(event: any): void {
    this._dataGridService.mapDatagridPagingToPagedSearch(event, this.searchParams);

    this.isSearching = true;

    if (this.profileId > 0) {
      this.searchParams.ProfileId == this.profileId;
    }

    this._imageService.searchImages(this.searchParams).then((data: ImageSearchResult) => {
      this.imageSearchResult = data;

      //update the search params based on current page number etc
      this._dataGridService.mapPagedResultsToPagedSearch(data, this.searchParams);
      if (data.TotalCount > 0) {
        this.searchHasResults = true;
      } else {
        this.searchHasResults = false;
      }
      this.searchPerformed = true;
      this.isSearching = false;
    });
  }

  public selectImage = (selImage: Image): void => {
    this.value = selImage.RelativePath;
    this.selectedImage = selImage;
    this.emitOutputObject();
    this.onImageSelected.emit(this.selectedImage);
    this.hideSearch();
  };

  public onUpload = ($event: any): void => {
    //let file = $event.files[0];
    //filter the list for the uploaded file name
    //this.searchParams.RestrictToWebServerFileImages = false;
    //this.searchParams.RestrictToWebContentImages = true;

    //this.searchParams.FileName = file.name;
    //this.selectedImageTypeId = 1;
    //this.imageSelectedSource = this.getWebContentImageSourceUrl(this.searchParams.WebContentId);
    //this.value = file.RelUrl

    if (this.searchParams.ProfileId > 0) {
      this._imageService.getLastProfileWebContentImage(this.searchParams.ProfileId).then((data: Image) => {
        this.selectedImage = data;
        this.value = data.RelativePath;
        this.emitOutputObject();
        this.hideSearch();

        if (this.autoSelectOnImageUpload) this.selectImage(this.selectedImage);
      });
    } else {
      this._imageService.getLastWebContentImage().then((data: Image) => {
        this.selectedImage = data;
        this.value = data.RelativePath;
        this.emitOutputObject();
        this.hideSearch();

        if (this.autoSelectOnImageUpload) this.selectImage(this.selectedImage);
      });
    }
  };
  public onError = ($event: any): void => {
    let test = $event;
  };

  public getWebContentImageSourceUrl = (contentId: number): string => {
    return this._imageService.getWebContentImageSourceUrl(contentId);
  };

  public setImageProfileIdFilter = (profileId: number): void => {
    this.searchParams.ProfileId = profileId;
    this.selectedImageTypeId = 1;
    this.searchParams.RestrictToWebContentImages = true;
    this.searchParams.RestrictToWebServerFileImages = false;

    if (profileId > 0) {
      this.uploadImageUrl = this._webContentService.getWebContentProfileImageUrl(profileId);
    } else {
      this.uploadImageUrl = this._webContentService.getWebContentImageUrl();
    }
    this.searchImages(null);
  };

  public clearSelectedImage = (): void => {
    this.value = '';
    this.selectedImage = new Image();
    this.emitOutputObject();
  };

  public imageTypeChange = (data: string) => {
    // it's possible for the httpsUrl to be unset at this point. This breaks image upload. So we make sure we have the right URL here.
    if (this.uploadImageUrl.startsWith('/')) this.uploadImageUrl = this._imageService.getWebContentImageUploadAbsoluteUrl();

    this.selectedImageTypeId = parseInt(data);
    if (this.selectedImageTypeId == 0) {
      this.searchParams.RestrictToWebContentImages = false;
      this.searchParams.RestrictToWebServerFileImages = false;
    }

    if (this.selectedImageTypeId == 1) {
      this.searchParams.RestrictToWebContentImages = true;
      this.searchParams.RestrictToWebServerFileImages = false;
    }
    if (this.selectedImageTypeId == 2) {
      this.searchParams.RestrictToWebContentImages = false;
      this.searchParams.RestrictToWebServerFileImages = true;
    }

    this.searchImages(null);
  };
}
